import { render, staticRenderFns } from "./Attachments.vue?vue&type=template&id=4e8a0d48&scoped=true&"
import script from "./Attachments.vue?vue&type=script&lang=js&"
export * from "./Attachments.vue?vue&type=script&lang=js&"
import style0 from "./Attachments.vue?vue&type=style&index=0&id=4e8a0d48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8a0d48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e8a0d48')) {
      api.createRecord('4e8a0d48', component.options)
    } else {
      api.reload('4e8a0d48', component.options)
    }
    module.hot.accept("./Attachments.vue?vue&type=template&id=4e8a0d48&scoped=true&", function () {
      api.rerender('4e8a0d48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/vendors/bids/Attachments.vue"
export default component.exports